import Image from "../Image";
import "../../assets/styles/modal-image.css";

const ModalImage = ({ data }) => {
  // Evita erros quando o modal é fechado e data fica null
  if (!data || !data.image) {
    return null;
  }

  const href = data.href || data.link || null;
  const target = data.target || (href ? "_blank" : undefined);
  const rel = data.rel || (target === "_blank" ? "noopener noreferrer" : undefined);

  const Img = <Image image={data.image} title={data.alt ?? ""} />;

  return (
    <div className="modal-image">
      {href ? (
        <a href={href} target={target} rel={rel} aria-label={data.alt || "Abrir link"}>
          {Img}
        </a>
      ) : (
        Img
      )}
    </div>
  );
};

export default ModalImage;
